export const AERA_PAGE_CARD_CLASS =
  "rounded-2xl border border-aera-lightgray/80 bg-aera-white";
